/* import __COLOCATED_TEMPLATE__ from './upload-box.hbs.js'; */
var _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { BASE_PATH } from '@clients/cloud-vagrant-box-registry';
import cookieAuthEnabled from 'core/helpers/cookie-auth-enabled';
let _class = (_class2 = class _class2 extends Component {
  constructor(owner, args) {
    super(owner, args);

    // autoStart is default (i.e., match on true or undefined)
    _initializerDefineProperty(this, "api", _descriptor, this);
    _initializerDefineProperty(this, "vagrantContext", _descriptor2, this);
    if (this.args.autoStart !== false) void this.upload();
  }
  get apiKey() {
    if (cookieAuthEnabled()) {
      return '';
    }
    const config = this.api.config(BASE_PATH);
    // @ts-expect-error: type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return config.apiKey();
  }
  async upload(provider) {
    const p = provider ?? this.args.provider;
    const isCookieAuthEnabled = cookieAuthEnabled();

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    await p?.upload(this.api, this.apiKey, isCookieAuthEnabled);
    this.args.onUpload?.(this.args.provider.succeeded);
  }
  retry(provider) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.upload(provider);
  }
  remove(provider) {
    // This should be a modal or something? Ugh
    this.args.providers.remove(provider.id);
    this.args.onUpload?.(true);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "vagrantContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "retry", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "retry"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "remove", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "remove"), _class2.prototype), _class2);
export { _class as default };